import { hexToRgb } from '@mui/material';

export const filterProps = (...propNames: string[]) => ({
  shouldForwardProp: (propName: string) => propNames.indexOf(propName) < 0,
});

export const hexToRgba = (hex: string, alpha: number) =>
  `${hexToRgb('#6386DB').slice(0, -1)}, ${alpha})`;
